<template>
  <el-dialog title="添加用户" :visible="visible" width="500px" :close-on-click-modal="false"
    @close="$emit('update:visible', false)" class="add-user-dialog">
    <el-form :model="form" :rules="rules" ref="formRef" label-width="80px" label-position="left">
      <el-form-item label="用户名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入用户名称" />
      </el-form-item>
      <el-form-item label="手机号码" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号码" />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio label="1">启用</el-radio>
          <el-radio label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-radio-group v-model="form.sex">
          <el-radio label="0">男</el-radio>
          <el-radio label="1">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="角色" prop="role">
        <el-select v-model="form.role" placeholder="请选择" multiple>
          <el-option v-for="role in roleList" :key="role.id" :label="role.title" :value="role.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="用户账号" prop="companyAccount">
        <el-input v-model="form.companyAccount" placeholder="请输入用户账号" />
      </el-form-item>
      <el-form-item label="公司" prop="companyId">
        <el-select v-model="form.companyId" placeholder="请选择">
          <el-option v-for="company in companyList" :key="company.company_id" :label="company.company_name"
            :value="company.company_id" />
        </el-select>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="form.password" placeholder="请输入密码" :type="showPassword ? 'text' : 'password'">
          <i slot="suffix" class="el-icon-view" @click="showPassword = !showPassword"></i>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { roleList, getCompanyList, userRegister } from '@/api/api'

export default {
  name: 'AddUserDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        status: '1',
        sex: '0',
        role: [],
        password: 'password.0',
        companyAccount: '',
        companyId: ''
      },
      showPassword: false,
      rules: {
        name: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        status: [{ required: true, message: '请选择用户状态', trigger: 'change' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        role: [{ required: true, message: '请选择角色', trigger: 'change' }],
        password: [{ required: false, message: '请输入密码', trigger: 'blur' }],
        companyAccount: [{ required: true, message: '请输入公司账户', trigger: 'blur' }],
        companyId: [{ required: true, message: '请选择公司', trigger: 'change' }]
      },
      roleList: [],
      companyList: []
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.fetchRoleList();
        this.fetchCompanyList();
      }
    }
  },
  methods: {
    // 获取角色列表
    fetchRoleList() {
      roleList({})
        .then(response => {
          console.log('roleList接口响应:', response);
          if (response && response.code === 200) {
            this.roleList = response.data.list || [];
            console.log('获取的角色列表:', this.roleList);
          } else {
            console.error('获取角色列表失败');
            this.roleList = [];
          }
        })
        .catch(error => {
          console.error('获取角色列表异常:', error);
          this.roleList = [];
        });
    },
    // 获取公司列表
    fetchCompanyList() {
      getCompanyList({})
        .then(response => {
          console.log('getCompanyList接口响应:', response);
          if (response && response.code === 200) {
            // 检查数据结构，确保companyList中的对象有合适的字段
            this.companyList = response.data || [];
            console.log('获取的公司列表:', this.companyList);
            // 打印第一个公司对象的结构，以便了解实际的字段名
            if (this.companyList.length > 0) {
              console.log('第一个公司对象的结构:', this.companyList[0]);
            }
          } else {
            console.error('获取公司列表失败');
            this.companyList = [];
          }
        })
        .catch(error => {
          console.error('获取公司列表异常:', error);
          this.companyList = [];
        });
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // 准备userRegister接口需要的参数
          const params = {
            name: this.form.name,
            phone: this.form.phone,
            password: this.form.password,
            account: this.form.companyAccount,
            company_id: this.form.companyId,
            status: this.form.status,
            sex: this.form.sex,
            role: this.form.role
          };

          console.log('调用userRegister接口，参数:', params);

          // 调用userRegister接口
          userRegister(params)
            .then(response => {
              console.log('userRegister接口响应:', response);
              if (response && response.code === 200) {
                this.$message.success('添加用户成功');
                this.$emit('submit', this.form);
                this.$emit('update:visible', false);
              } else {
                this.$message.error('添加用户失败');
              }
            })
            .catch(error => {
              console.error('添加用户异常:', error);
              this.$message.error('添加用户异常，请重试');
            });
        }
      });
    }
  }
}
</script>

<style scoped>
::v-deep .el-form-item {
  margin-bottom: 20px !important;
}
</style>